export default (num) =>
  parseInt(num.toString().split("").slice(-2).join(""), 10);
